"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ROUTE = void 0;
var ROUTE = 'account-defaults';
exports.ROUTE = ROUTE;